module.exports = __webpack_public_path__ + "static/skitrip2-3f57b836b6a5fe4fab897e623091cec7.jpg";